import React, { useState } from 'react';
import expandIcon from './assests/expand.svg';
import expandHighlightIcon from './assests/expand-highlight.svg';
import expandedIcon from './assests/expanded.svg';
import expandedHighlightIcon from './assests/expanded-highlight.svg';
import CommonBubble from '@home/components/CommonBubble';
import './index.scss';

interface ExpandCollapseButtonProps {
    isExpanded: boolean;
    onClick: (e?: React.MouseEvent) => void;
    title?: React.ReactNode;
    className?: string;
    onTrackToggle?: (nextExpanded: boolean) => void;
}

const ExpandCollapseButton: React.FC<ExpandCollapseButtonProps> = ({
    isExpanded,
    onClick,
    title,
    className = '',
    onTrackToggle,
}) => {
    const [isHovered, setIsHovered] = useState(false);

    const handleClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        onTrackToggle?.(!isExpanded);
        onClick(e);
    };

    const getIconSrc = () => {
        if (isExpanded) {
            return isHovered ? expandedHighlightIcon : expandedIcon;
        }
        return isHovered ? expandHighlightIcon : expandIcon;
    };

    return (
        <CommonBubble content={isExpanded ? 'Fold All' : 'Expand All'} trigger="hover" placement='right' dark>
            <div
                className={`dbs-expand-collapse-button ${className}`}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                onClick={handleClick}
            >

                <img
                    src={getIconSrc()}
                    alt={isExpanded ? 'Fold All' : 'Expand All'}
                    className="dbs-expand-collapse-button__icon"
                    onClick={handleClick}
                />

                {title && (
                    <span className={`dbs-expand-collapse-button__title ${isHovered ? 'dbs-expand-collapse-button__title--hovered' : ''}`}>
                        {title}
                    </span>
                )}

            </div>
        </CommonBubble>
    );
};

export default ExpandCollapseButton;
